import { __export } from "../_virtual/rolldown_runtime.js";
import { Document } from "./document.js";
import { BaseDocumentTransformer, MappingDocumentTransformer } from "./transformers.js";

//#region src/documents/index.ts
var documents_exports = {};
__export(documents_exports, {
	BaseDocumentTransformer: () => BaseDocumentTransformer,
	Document: () => Document,
	MappingDocumentTransformer: () => MappingDocumentTransformer
});

//#endregion
export { BaseDocumentTransformer, Document, MappingDocumentTransformer, documents_exports };
//# sourceMappingURL=index.js.map